import { heroCover, heroKeywords, hotSections } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-10 px-4 pb-14 pt-28 md:flex-row md:items-center md:gap-14 md:pb-20 md:pt-36">
        {/* 文案优先：左侧大字标题 */}
        <div className="flex w-full flex-col md:w-[58%]">
          <div className="mb-5 inline-flex w-fit items-center gap-2 rounded-full bg-accent-100 px-3 py-1.5 text-sm text-accent-900">
            <span className="relative flex h-2 w-2 items-center justify-center">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500" />
            </span>
            今日已有 3 个新瓜入档
          </div>

          <h2 className="font-heading text-4xl font-bold leading-[1.15] tracking-tight text-foreground-950 md:text-6xl">
            散落全网的<span className="text-primary-500">黑料</span>，
            <br className="hidden md:block" />
            从这一站看全。
          </h2>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            98黑料把散落各处的黑料合集、汇总帖与整理清单集中起来。按时间线理顺事件脉络、给出避雷指南——不用再逐帖翻楼，想快速掌握一个瓜点，来这里补课就够了。
          </p>

          {/* 关键词胶囊 */}
          <div className="mt-6 flex flex-wrap items-center gap-2">
            {heroKeywords.map((k, i) => (
              <span
                key={k}
                className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm transition-colors ${
                  i === 0
                    ? "bg-primary-500 text-background-50"
                    : "bg-secondary-100 text-secondary-900 hover:bg-secondary-200"
                }`}
              >
                {k}
              </span>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#timeline"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-base text-background-50 transition-colors hover:bg-primary-600"
            >
              从时间线开始补课
              <i className="ri-arrow-right-line text-lg" />
            </a>
            <a
              href="#guide"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 rounded-full border border-foreground-300 px-6 py-3 text-base text-foreground-800 transition-colors hover:border-foreground-950 hover:bg-foreground-950 hover:text-background-50"
            >
              先看避雷指南
            </a>
          </div>

          {/* 板块速览 */}
          <div className="mt-9 flex flex-wrap items-center gap-x-3 gap-y-2 text-sm text-foreground-500">
            <span className="flex items-center gap-1.5 text-foreground-400">
              <i className="ri-apps-2-line text-base" />
              覆盖板块
            </span>
            {hotSections.map((s) => (
              <span key={s} className="whitespace-nowrap text-foreground-600">
                {s}
              </span>
            ))}
          </div>
        </div>

        {/* 视觉陪衬：右侧封面 */}
        <div className="relative w-full md:w-[42%]">
          <div className="relative overflow-hidden rounded-lg">
            <img
              src={heroCover}
              alt="98黑料 档案封面：剪辑的证据碎片与红胶带"
              title="98黑料 时间线整理 归档封面"
              className="aspect-[3/4] w-full rounded-lg object-cover object-top"
            />
            <div className="absolute left-3 top-3 flex items-center gap-2 rounded-full bg-background-50/90 px-3 py-1.5 text-xs text-foreground-800 backdrop-blur">
              <i className="ri-flashlight-line text-primary-500" />
              本期封面专题
            </div>
            <div className="absolute bottom-3 left-3 right-3 rounded-md bg-background-950/70 p-3 backdrop-blur">
              <p className="text-xs text-background-100/90">「主播合约风波」完整时间线整理</p>
              <p className="mt-1 font-heading text-sm font-bold text-background-50">从起爆到回应的每一环</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}